 <template>
  <div>
    <vx-card
      :title="routine.title"
      title-color="primary"
      :subtitle="frequency">

    <template slot="no-body">

      started: {{routine.startedOn | date}}
      daysRunning: {{daysRunning}}
      <p>Urgency: {{urgency}}</p>

      <!-- <h5>Length: {{length}} days</h5> -->
      <p>Done days: {{datesDone.length}} days</p>
      <p>Done days: {{datesDone}} days</p>

      <div>
        <vue-apex-charts type="radialBar" height="150" :options="chartOptions" :series="[successLevel]" />
      </div>

      <div class="flex">
      <flat-pickr :config="configdateTimePicker" ref="calendar" v-model="datesRaw" placeholder="Inline Picker" />

      <vs-button @click="openCalendar">
        open calendar
      </vs-button>
      <vs-button @click.stop="sidebarActive=true">
        open sidebar
      </vs-button>
    </div>

    </template>
    </vx-card>

    <Sidebar :initValue="sidebarActive" title="Routine" @close="sidebarActive=false">
      {{routine.title}}
      {{routine}}
    </Sidebar>
</div>
</template>

<script>
import _ from 'lodash'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import VueApexCharts from 'vue-apexcharts'
import Sidebar from '@/views/Self-Improvee/Generic/Sidebar'

// import _ from 'lodash'
// import draggable from 'vuedraggable'
// import keepOrderBy from '@/helpers/keepOrderBy'


export default {
  components: {
    flatPickr,
    VueApexCharts,
    Sidebar
  },
  props: {
    routine: {
      type: Object,
      required: true,
    },
  },

  // computed: {
  //   titleColor: "primary"
  // }
  data () {
    return {
      sidebarActive: false,
      datesRaw: null,
      chartOptions: {
        labels: ['last 30d'],
        plotOptions: {
          radialBar: {
            dataLabels: {
              total: {
                show: false,
                // label: 'TOTAL'
              }
            }
          }
        },
      },
      configdateTimePicker: {
        disableMobile: false,
        parseDate: (datestr) => new Date(datestr),
        minDate: this.routine.startedOn,
        maxDate: new Date(),
        // disable: [(date) => { return date < this.routine.startedOn }],
        altInput: true, // optional
        altInputClass: 'hide-me',  // optional
        wrap: true,
        mode: 'multiple',
        locale: { firstDayOfWeek: 1 }
      },
      addSubTaskSkeleton: null,
      subtasksArray: []
    }
  },
  methods: {
    selected (a) {
      console.log(a)
    },
    openCalendar () {
      this.$forceNextTick(() => this.$refs['calendar'].fp.toggle())
    },
    datesDiff (a, b) {
      const mls = 1000 * 60 * 60 * 24
      return Math.round((a - b) / mls)
    }
  },
  computed: {
    // daysSinceStart () {
    //   return
    // },
    datesDone () {
      if (this.datesRaw) {
        console.log(this.datesRaw)
        return _.map(this.datesRaw.split(','), (d) => new Date(d))
      } else {
        return []
      }
    },
    datesDoneCount () {
      if (this.datesDone) {
        return this.datesDone.length
      } else {
        return 0
      }

    },
    daysRunning () {
      return Math.abs(this.datesDiff(this.routine.startedOn, new Date()))
    },
    urgency () {
      return '???'
    },
    successLevel () {
      let lvl = 0

      if (this.routine.frequency_period === 'daily') {
        lvl = 100 * (this.datesDoneCount / this.daysRunning)
      } else if (this.routine.frequency_period === 'month') {
        const potential = this.routine.frequency_count * (this.daysRunning / 30)
        lvl = 100 * (this.datesDoneCount / potential)
      } else {
        lvl = 10
      }

      if (lvl > 100) {
        return 100
      } else {
        return Math.round(lvl)
      }
    },
    frequency () {
      if (this.routine.frequency_period === 'daily') {
        return 'Daily'
      } else if (this.routine.frequency_count === 1) {
        return `Once a ${this.routine.frequency_period}`
      } else {
        return `${this.routine.frequency_count} times a ${this.routine.frequency_period}`
      }
    }
  }
}

</script>

<style lang="scss">
.hide-me {
  visibility: hidden;
  width: 0;
}

</style>
